export enum EntityTypeEnum {
    LECTURES = 'LECTURE',
    USERS = 'USER'
}
